/**
 * SignUp
 * @type {{success: boolean, loading: boolean}}
 */
import {signUpTypes} from "../../actions/AuthActions/AuthActionsTypes/SignUpActionsTypes";

const initSignUpState = {
    loading: false,
    success: false,
};

const SignUpReducer = (state = initSignUpState, action) => {
    switch (action.type) {
        case signUpTypes.SIGN_UP_REQUEST: {
            return Object.assign({}, state, {
                loading: true,
                success: false,
            });
        }

        case signUpTypes.SIGN_UP_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                success: true,
            });
        }

        case signUpTypes.SIGN_UP_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                success: false,
            });
        }

        default: {
            return state;
        }
    }
};

export default SignUpReducer;
